<template>
  <main class="gs2">
    <LightsImage />

    <WelcomeSection />

    <ButtonSection
      :isStep1="isStep1"
      @goToStep2="goToStep2"
      @goToLogin="goToLogin"
      @goToRegistration="showRegistration"
    />

    <PrizesCarousel />

    <WinnersHistory
      v-if="showWinners"
      :winner-list="winnerList"
    />
  </main>

  <RegisterViaSmsModal
    v-if="isRegisterViaSmsModalOpen"
    @redirect:loginPage="redirectToLoginPageFromRegisterModal"
  />
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import WelcomeSection from '@/views/getStarted/components/WelcomeSection.vue';
import ButtonSection from '@/views/getStarted/components/ButtonSection.vue';
import PrizesCarousel from '@/components/carousel/PrizesCarousel.vue';
import LightsImage from '@/components/image/LightsImage.vue';
import RegisterViaSmsModal from '@/components/modal/RegisterViaSmsModal.vue';
import WinnersHistory from '@/views/getStarted/components/WinnersHistory.vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useLocaleStore from '@/store/modules/locale.js';
import usePageNavigation from '@/hooks/usePageNavigation.js';
import useRegisterHook from '@/hooks/useRegister.js';
import { retrieveWinners } from '@/services/winners.js';

const appSettingsStore = useAppSettingsStore();
const localeStore = useLocaleStore();

const { redirectTo } = usePageNavigation();
const {
  isRegisterViaSmsModalOpen,
  redirectToIndexStep: showRegistration,
  redirectToLoginPage: redirectToLoginPageFromRegisterModal,
} = useRegisterHook();

const isStep1 = ref(true);
const winnerList = ref([]);
const fetchingData = ref(false);

const showWinners = computed(() => !appSettingsStore.isWinnersDisabled && !fetchingData.value);

const goToStep2 = () => {
  isStep1.value = false;
};

const goToLogin = () => {
  redirectTo('Login');
};

onMounted(async () => {
  fetchingData.value = true;

  if (!appSettingsStore.isWinnersDisabled) {
    winnerList.value = await retrieveWinners(localeStore.currentLanguage).then(({ data }) => data).catch(() => []);
  }

  fetchingData.value = false;
});
</script>
